import React, { useState } from "react";
import styled from "styled-components";
import { confirmSignUp, resendSignUpCode } from "aws-amplify/auth";
import { useNavigate, useLocation } from "react-router-dom";
import { Layout } from "../components/Layout";
import { AppDispatch, searchEmail } from "../store";
import { saveToLocalStorage } from "../utils/localStorageUtil";
import { useDispatch } from "react-redux";

const Impersonation: React.FC = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch<AppDispatch>();

  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || "");
  const [error, setError] = useState("");
  const [resendMessage, setResendMessage] = useState("");
  const [isConfirmLoading, setIsConfirmLoading] = useState(false);

  const handleConfirm = async () => {
    setError("");
    setIsConfirmLoading(true);
    if (!email) {
      setError("Email are required.");
      setIsConfirmLoading(false);
      return;
    }

    try {
      const searchEmailResponse = await dispatch(
        searchEmail({ email })
      );

      if (searchEmailResponse.meta.requestStatus === "fulfilled" && searchEmailResponse.payload?.result?.officialId) {
        saveToLocalStorage("firmId", searchEmailResponse.payload?.result?.firmId);
        saveToLocalStorage("officialId", searchEmailResponse.payload?.result?.officialId);
        navigate("/");
      }
      else if (searchEmailResponse.meta.requestStatus === "fulfilled") {
        setResendMessage("");
        setError("You are not onboarded");
        setIsConfirmLoading(false);
      }
    } catch (error: any) {
      setResendMessage("");
      setError(error.message);
    } finally {
      setIsConfirmLoading(false);
    }
  };

  return (
    <CenteredContainer>
      <ConfirmBox>
        <Title>Impersonation</Title>
        <Form onSubmit={handleConfirm} noValidate>
          <FieldBox>
            <Label>Email</Label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
          </FieldBox>
          {error && <ErrorText>{error}</ErrorText>}
          {resendMessage && <SuccessText>{resendMessage}</SuccessText>}
          <ConfirmButton type="button" onClick={handleConfirm}>
            {isConfirmLoading ? <LoadingSpinner /> : "Do It"}
          </ConfirmButton>
        </Form>
      </ConfirmBox>
    </CenteredContainer>
  );
};

export default Impersonation;

const CenteredContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  background-color: #f5f5f5;
`;

const ConfirmBox = styled.div`
  width: 50%;
  background: white;
  padding: 40px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h1`
  font-size: 30px;
  margin-bottom: 20px;
  color: ${(props) => props.theme.colors.secondary};
`;

const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
  align-items: center;
`;

const FieldBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;
`;

const Label = styled.label`
  font-size: 14px;
  margin-bottom: 5px;
  color: #333;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-sizing: border-box;
`;

const ConfirmButton = styled.button`
  width: 50%;
  padding: 10px;
  background-color: ${(props) => props.theme.colors.secondary};
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 20px;
  display: flex;
  justify-content: center;
`;

const ErrorText = styled.p`
  font-size: 12px;
  color: red;
  margin-top: 5px;
`;

const SuccessText = styled.p`
  font-size: 12px;
  color: green;
  margin-top: 5px;
`;

const LoadingSpinner = styled.div`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top: 2px solid white;
  width: 12px;
  height: 12px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
